import React, { useState } from "react";
import Sidebar from "../../../components/Sidebar/Sidebar";
import AdminList from "../../../components/AdminList/AdminList";
import Modal from "../../../components/Modal/Modal";
import { getBlogs, deleteBlog, createBlog, updateBlog } from "../../../utils/api";

const columns = [
  { key: "title", label: "Title" },
  { key: "author", label: "Author" },
  { 
    key: "publishDate", 
    label: "Publish Date",
    render: (value) => value ? new Date(value).toLocaleDateString() : "-"
  },
];

const filters = [
  {
    key: "author",
    label: "Filter by Author",
    type: "search"
  },
];

const initialFormData = {
  title: "",
  content: "",
  author: "Maha Sabha",
  imageUrl: ""
};

export default function Blogs() {
  const [isModalOpen, setModalOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedBlog, setSelectedBlog] = useState(null);
  const [formData, setFormData] = useState(initialFormData);
  const [loading, setLoading] = useState(false);

  const handleAdd = () => {
    setFormData(initialFormData);
    setIsEditMode(false);
    setSelectedBlog(null);
    setModalOpen(true);
  };

  const handleEdit = (blog) => {
    setSelectedBlog(blog);
    setFormData({
      title: blog.title || "",
      content: blog.content || "",
      author: blog.author || "Maha Sabha",
      imageUrl: blog.imageUrl || ""
    });
    setIsEditMode(true);
    setModalOpen(true);
  };

  const handleView = (blog) => {
    handleEdit(blog);
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          const maxSize = 500;
          let width = img.width;
          let height = img.height;
          
          if (width > height) {
            if (width > maxSize) {
              height = (height * maxSize) / width;
              width = maxSize;
            }
          } else {
            if (height > maxSize) {
              width = (width * maxSize) / height;
              height = maxSize;
            }
          }
          
          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0, width, height);
          const compressedBase64 = canvas.toDataURL('image/jpeg', 0.5);
          
          setFormData(prev => ({ ...prev, imageUrl: compressedBase64 }));
        };
        img.src = reader.result;
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (isEditMode && selectedBlog) {
        await updateBlog(selectedBlog._id, formData);
        alert("Blog updated successfully!");
      } else {
        await createBlog(formData);
        alert("Blog created successfully!");
      }
      setModalOpen(false);
      window.location.reload();
    } catch (error) {
      alert(error.message || "Failed to save blog");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="dashboard-container">
      <Sidebar />
      <main className="dashboard-content">
        <AdminList
          title="Blogs"
          fetchData={getBlogs}
          deleteData={deleteBlog}
          columns={columns}
          onEdit={handleEdit}
          onAdd={handleAdd}
          onView={handleView}
          filters={filters}
          searchPlaceholder="Search blogs..."
        />
      </main>

      {/* Create/Edit Blog Modal */}
      <Modal
        isOpen={isModalOpen}
        onClose={() => setModalOpen(false)}
        title={isEditMode ? "Edit Blog" : "Add New Blog"}
        size="large"
      >
        <form onSubmit={handleSubmit}>
          <div className="form-section">
            <h3>Basic Information</h3>
            <div className="form-group">
              <label>Title *</label>
              <input
                type="text"
                name="title"
                value={formData.title}
                onChange={handleFormChange}
                required
                placeholder="Enter blog title"
              />
            </div>
            <div className="form-group">
              <label>Author</label>
              <input
                type="text"
                name="author"
                value={formData.author}
                onChange={handleFormChange}
                placeholder="Enter author name"
              />
            </div>
          </div>

          <div className="form-section">
            <h3>Content</h3>
            <div className="form-group">
              <label>Content *</label>
              <textarea
                name="content"
                value={formData.content}
                onChange={handleFormChange}
                rows="10"
                required
                placeholder="Enter blog content"
              />
            </div>
          </div>

          <div className="form-section">
            <h3>Image</h3>
            <div className="form-group">
              <label>Cover Image</label>
              <input
                type="file"
                accept="image/*"
                onChange={handleImageChange}
                className="file-input"
              />
              {formData.imageUrl && (
                <div className="image-preview">
                  <img src={formData.imageUrl} alt="Preview" style={{ maxWidth: '100px', maxHeight: '100px' }} />
                  <button type="button" onClick={() => setFormData(prev => ({ ...prev, imageUrl: "" }))}>
                    Remove
                  </button>
                </div>
              )}
            </div>
          </div>

          <div className="form-actions">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => setModalOpen(false)}
            >
              Cancel
            </button>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? "Saving..." : (isEditMode ? "Update Blog" : "Create Blog")}
            </button>
          </div>
        </form>
      </Modal>
    </div>
  );
}
